var path = 'src/app/patients/india-ethnicities/india-ethnicities.html';
var html = "<h1 class=page-header>Ethnicities</h1> <div india-ethnicities-component patient=patient></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/india-ethnicities/india-ethnicities.html
 ** module id = 493
 ** module chunks = 0
 **/